define('SEOImprovements.PDP.View', [
    'ProductDetails.ImageGallery.View',
    'ProductDetails.Full.View',
    'underscore',
    'jQuery',
    'SC.Configuration'
], function fnSEOImprovementsPDPView(
    ProductDetailsImageGalleryView,
    ProductDetailsFullView,
    _,
    jQuery,
    Configuration
) {
    'use strict';

    _.extend(ProductDetailsImageGalleryView.prototype, {
        getContext: _.wrap(ProductDetailsImageGalleryView.prototype.getContext, function getContext(fn) {
            var originalRet = fn.apply(this, _.toArray(arguments).slice(1));
            var self = this;
            _.each(originalRet.images, function eachImg(image) {
                if (!image.altimagetext) {
                    image.altimagetext = self.model.getItem().get('displayname');
                }
            });
            return originalRet;
        })
    });

    _.extend(ProductDetailsFullView.prototype, {
        getMetaDescription: _.wrap(ProductDetailsFullView.prototype.getMetaDescription, function getMetaDescription(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            var ogDescription = jQuery("meta[property='og\\:description']");
            var descriptionFieldId;
            var descriptionField;
            var div;
            var item = this.model.getItem();
            var descriptionText;

            if (item.get('custitem_t3_item_dosage_form') && item.get('custitem_sip_pedigree_item_size')){
                // eslint-disable-next-line max-len
                ret = item.get('_sku') + ' - ' + this.getTitle() + ' - ' + item.get('custitem_t3_item_dosage_form') + ' - ' + item.get('custitem_sip_pedigree_item_size');
            }

            if (!ret) {
                descriptionFieldId = Configuration.get('seo.productDescriptionField');
                // eslint-disable-next-line max-len
                descriptionField = descriptionFieldId && this.model.get('item').get(descriptionFieldId) ? this.model.get('item').get(descriptionFieldId) : this.model.get('item').get('storedescription') || this.model.get('item').get('featureddescription');
                // To remove html tags
                div = document.createElement('div');
                div.innerHTML = descriptionField;
                descriptionText = div.innerText;
                ret = descriptionText;
            }

            if (ogDescription.length) {
                ogDescription.attr('content', ret);
            } else {
                ogDescription = jQuery(document.createElement('meta'));
                ogDescription.attr('property', 'og:description');
                ogDescription.attr('content', ret);
                jQuery('head').append(ogDescription);
            }

            return ret;
        }),
        getTitle: _.wrap(ProductDetailsFullView.prototype.getTitle, function getTitle(fn) {
            var ret = fn.apply(this, _.toArray(arguments).slice(1));
            var item = this.model.getItem();
            if (item.get('displayname') && item.get('manufacturer')) {
                return item.get('displayname') + ' - ' + item.get('manufacturer');
            }
            return ret;
        })
    });
});
